import React, { useState } from 'react';
import { User } from '../../../interfaces/User';
import './AvatarFilter.css';
import AvatarImage from '../../ui/Avatar/AvatarImage';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

interface AvatarFilterProps {
    users: User[];
    selectedUserIds: string[];
    onSelectionChange: (userIds: string[]) => void;
}

const AvatarFilter: React.FC<AvatarFilterProps> = ({ users, selectedUserIds, onSelectionChange }) => {
    const MAX_VISIBLE_AVATARS = 4;
    const [showDropdown, setShowDropdown] = useState(false);

    const handleAvatarClick = (userId: string) => {
        const newSelection = selectedUserIds.includes(userId)
            ? selectedUserIds.filter(id => id !== userId)
            : [...selectedUserIds, userId];
        onSelectionChange(newSelection);
    };

    const visibleUsers = users.slice(0, MAX_VISIBLE_AVATARS);
    const hiddenUsers = users.slice(MAX_VISIBLE_AVATARS);

    const isAnyHiddenUserSelected = hiddenUsers.some(user => selectedUserIds.includes(user.id));

    return (
        <div className="avatar-filter-container">
            {visibleUsers.map(user => (
                <div
                    key={user.id}
                    className={`avatar-container ${selectedUserIds.includes(user.id) ? 'selected' : ''}`}
                    onClick={() => handleAvatarClick(user.id)}
                >
                    <AvatarImage userId={user.id} size="xs" displayName={user.displayName} />
                    <div className="avatar-tooltip">
                        <strong>{user.displayName}</strong>
                        <span className="text-muted">{user.email}</span>
                    </div>
                </div>
            ))}

            {hiddenUsers.length > 0 && (
                <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
                    <Dropdown.Toggle as="div" className={`avatar-plus-button ${isAnyHiddenUserSelected ? 'selected' : ''}`}>
                        <div className="plus-icon-container cursor-pointer">
                            <FontAwesomeIcon icon={faPlus} />
                        </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="max-h-72 overflow-y-auto overflow-x-hidden">
                        {hiddenUsers.map(user => (
                            <Dropdown.Item key={user.id} onClick={() => handleAvatarClick(user.id)}>
                                <div className="d-flex align-items-center">
                                    <input
                                        type="checkbox"
                                        readOnly
                                        checked={selectedUserIds.includes(user.id)}
                                        className="me-2"
                                    />
                                    <AvatarImage userId={user.id} size="xxs" displayName={user.displayName} />
                                    <span className="ms-2">{user.displayName}</span>
                                </div>
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            )}
        </div>
    );
};

export default AvatarFilter;

